
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/copiercosts",
      function () {
        return require("private-next-pages/copiercosts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/copiercosts"])
      });
    }
  